"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports.colors = exports.statusColors = exports.monochromeColors = exports.backgroundColors = exports.actionColors = exports.textColors = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@mui/material/styles");

var _AlertTheme = _interopRequireDefault(require("./components/AlertTheme"));

var _AlertTitleTheme = _interopRequireDefault(require("./components/AlertTitleTheme"));

var _AppBarTheme = _interopRequireDefault(require("./components/AppBarTheme"));

var _BreadcrumbsTheme = _interopRequireDefault(require("./components/BreadcrumbsTheme"));

var _ButtonTheme = _interopRequireDefault(require("./components/ButtonTheme"));

var _CheckboxTheme = _interopRequireDefault(require("./components/CheckboxTheme"));

var _ChipTheme = _interopRequireDefault(require("./components/ChipTheme"));

var _CircularProgressTheme = _interopRequireDefault(require("./components/CircularProgressTheme"));

var _DialogActionsTheme = _interopRequireDefault(require("./components/DialogActionsTheme"));

var _DialogContentTheme = _interopRequireDefault(require("./components/DialogContentTheme"));

var _DialogTheme = _interopRequireDefault(require("./components/DialogTheme"));

var _DialogTitleTheme = _interopRequireDefault(require("./components/DialogTitleTheme"));

var _FormControlLabelTheme = _interopRequireDefault(require("./components/FormControlLabelTheme"));

var _FormHelperTextTheme = _interopRequireDefault(require("./components/FormHelperTextTheme"));

var _FormLabelTheme = _interopRequireDefault(require("./components/FormLabelTheme"));

var _IconButtonTheme = _interopRequireDefault(require("./components/IconButtonTheme"));

var _InputAdornmentTheme = _interopRequireDefault(require("./components/InputAdornmentTheme"));

var _InputBaseTheme = _interopRequireDefault(require("./components/InputBaseTheme"));

var _InputLabelTheme = _interopRequireDefault(require("./components/InputLabelTheme"));

var _LinearProgressTheme = _interopRequireDefault(require("./components/LinearProgressTheme"));

var _LinkTheme = _interopRequireDefault(require("./components/LinkTheme"));

var _ListItemIconTheme = _interopRequireDefault(require("./components/ListItemIconTheme"));

var _ListItemTextTheme = _interopRequireDefault(require("./components/ListItemTextTheme"));

var _MenuItemTheme = _interopRequireDefault(require("./components/MenuItemTheme"));

var _OutlinedInputTheme = _interopRequireDefault(require("./components/OutlinedInputTheme"));

var _PaperTheme = _interopRequireDefault(require("./components/PaperTheme"));

var _RadioTheme = _interopRequireDefault(require("./components/RadioTheme"));

var _SelectTheme = _interopRequireDefault(require("./components/SelectTheme"));

var _SnackbarContentTheme = _interopRequireDefault(require("./components/SnackbarContentTheme"));

var _SnackbarTheme = _interopRequireDefault(require("./components/SnackbarTheme"));

var _StepConnectorTheme = _interopRequireDefault(require("./components/StepConnectorTheme"));

var _StepContentTheme = _interopRequireDefault(require("./components/StepContentTheme"));

var _StepIconTheme = _interopRequireDefault(require("./components/StepIconTheme"));

var _StepLabelTheme = _interopRequireDefault(require("./components/StepLabelTheme"));

var _StepperTheme = _interopRequireDefault(require("./components/StepperTheme"));

var _StepTheme = _interopRequireDefault(require("./components/StepTheme"));

var _SwitchTheme = _interopRequireDefault(require("./components/SwitchTheme"));

var _TableBodyTheme = _interopRequireDefault(require("./components/TableBodyTheme"));

var _TableCellTheme = _interopRequireDefault(require("./components/TableCellTheme"));

var _TableHeadTheme = _interopRequireDefault(require("./components/TableHeadTheme"));

var _TablePaginationTheme = _interopRequireDefault(require("./components/TablePaginationTheme"));

var _TableRowTheme = _interopRequireDefault(require("./components/TableRowTheme"));

var _TableSortLabelTheme = _interopRequireDefault(require("./components/TableSortLabelTheme"));

var _TabsTheme = _interopRequireDefault(require("./components/TabsTheme"));

var _TabTheme = _interopRequireDefault(require("./components/TabTheme"));

var _TextFieldTheme = _interopRequireDefault(require("./components/TextFieldTheme"));

var _ToggleButtonTheme = _interopRequireDefault(require("./components/ToggleButtonTheme"));

var _TooltipTheme = _interopRequireDefault(require("./components/TooltipTheme"));

var _TypographyTheme = _interopRequireDefault(require("./components/TypographyTheme"));

var _CalendarTheme = _interopRequireDefault(require("./components/CalendarTheme"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultMuiTheme = (0, _styles.createTheme)();
var breakpoints = defaultMuiTheme.breakpoints;
var textColors = {
  ultramarine: '#00008c',
  lynch: '#666d92'
};
exports.textColors = textColors;
var actionColors = {
  bleuDigital100: '#0000ff',
  bleuDigital10: '#e5e5fd',
  bleuDigital05: '#f2f2ff',
  hover: '#3351E0',
  click: '#001EAE',
  selected: '#0000cc'
};
exports.actionColors = actionColors;
var backgroundColors = {
  white: '#ffffff',
  light: '#F6F6F8',
  userBlue: '#3970E6'
};
exports.backgroundColors = backgroundColors;
var monochromeColors = {
  grey10: '#EDEDF2',
  grey20: '#DADCE5',
  grey30: '#C2C5D3'
};
exports.monochromeColors = monochromeColors;
var statusColors = {
  greenIcon: '#289D15',
  greenText: '#4A801A',
  greenBackground: '#F4FAF6',
  orangeIcon: '#ED6508',
  orangeText: '#D92C01',
  orangeBackground: '#FFF4EC',
  redIcon: '#D82A2A',
  redText: '#D00000',
  redBackground: '#FEF4F5',
  mandyIcon: '#F14B82',
  mandyText: '#CF2A61',
  mandyBackground: '#FEEFF4',
  electricVioletIcon: '#C25CF5',
  electricVioletText: '#A33FD5',
  electricVioletBackground: '#F9F1FD',
  dodgerBlueIcon: '#6181FF',
  dodgerBlueText: '#385FFA',
  dodgerBlueBackground: '#EFF2FF',
  turquoiseIcon: '#1E9999',
  turquoiseText: '#2D7C6F',
  turquoiseBackground: '#E9F6F6',
  fuelYellowIcon: '#C37A13',
  fuelYellowText: '#A85C10',
  fuelYellowBackground: '#FAF2E7'
};
exports.statusColors = statusColors;

var colors = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, textColors), actionColors), backgroundColors), monochromeColors), statusColors);

exports.colors = colors;
var theme = (0, _styles.createTheme)({
  breakpoints: {
    values: {
      xs: 0,
      sm: 761,
      md: 1201,
      lg: 1921
    }
  },
  palette: {
    primary: {
      light: colors.bleuDigital100,
      main: colors.bleuDigital100,
      dark: colors.bleuDigital100
    },
    secondary: {
      light: colors.bleuDigital100,
      main: colors.bleuDigital100,
      dark: colors.bleuDigital100
    },
    text: {
      primary: colors.lynch,
      secondary: colors.selected
    },
    disabled: colors.grey30,
    cobalt: colors
  },
  typography: {
    fontFamily: 'Barlow'
  },
  shadows: ['none', '0 4px 8px rgba(102, 109, 146, 0.08)', '0 2px 4px rgba(102, 109, 146, 0.16)', '0 12px 24px rgba(102, 109, 146, 0.2)'].concat(Array(21).fill('none')),
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: 'Barlow'
        }
      }
    },
    MuiAlert: (0, _AlertTheme["default"])(colors),
    MuiAlertTitle: (0, _AlertTitleTheme["default"])(),
    MuiAppBar: (0, _AppBarTheme["default"])(colors),
    MuiBreadcrumbs: (0, _BreadcrumbsTheme["default"])(colors),
    MuiButton: (0, _ButtonTheme["default"])(colors, breakpoints),
    MuiCheckbox: (0, _CheckboxTheme["default"])(colors),
    MuiChip: (0, _ChipTheme["default"])(colors, breakpoints),
    MuiCircularProgress: (0, _CircularProgressTheme["default"])(colors),
    MuiDialogActions: (0, _DialogActionsTheme["default"])(breakpoints),
    MuiDialogContent: (0, _DialogContentTheme["default"])(colors, breakpoints),
    MuiDialog: (0, _DialogTheme["default"])(colors, breakpoints),
    MuiDialogTitle: (0, _DialogTitleTheme["default"])(colors, breakpoints),
    MuiFormControlLabel: (0, _FormControlLabelTheme["default"])(colors, breakpoints),
    MuiFormHelperText: (0, _FormHelperTextTheme["default"])(colors, breakpoints),
    MuiFormLabel: (0, _FormLabelTheme["default"])(colors),
    MuiIconButton: (0, _IconButtonTheme["default"])(colors),
    MuiInputAdornment: (0, _InputAdornmentTheme["default"])(colors),
    MuiInputBase: (0, _InputBaseTheme["default"])(colors, breakpoints),
    MuiInputLabel: (0, _InputLabelTheme["default"])(colors, breakpoints),
    MuiLinearProgress: (0, _LinearProgressTheme["default"])(colors),
    MuiLink: (0, _LinkTheme["default"])(colors),
    MuiListItemIcon: (0, _ListItemIconTheme["default"])(),
    MuiListItemText: (0, _ListItemTextTheme["default"])(),
    MuiMenuItem: (0, _MenuItemTheme["default"])(colors),
    MuiOutlinedInput: (0, _OutlinedInputTheme["default"])(colors, breakpoints),
    MuiPaper: (0, _PaperTheme["default"])(),
    MuiRadio: (0, _RadioTheme["default"])(colors),
    MuiSelect: (0, _SelectTheme["default"])(),
    MuiSnackbarContent: (0, _SnackbarContentTheme["default"])(colors),
    MuiSnackbar: (0, _SnackbarTheme["default"])(),
    MuiStepConnector: (0, _StepConnectorTheme["default"])(colors),
    MuiStepContent: (0, _StepContentTheme["default"])(colors),
    MuiStepIcon: (0, _StepIconTheme["default"])(colors),
    MuiStepLabel: (0, _StepLabelTheme["default"])(colors, breakpoints),
    MuiStepper: (0, _StepperTheme["default"])(),
    MuiStep: (0, _StepTheme["default"])(colors),
    MuiTableBody: (0, _TableBodyTheme["default"])(colors, breakpoints),
    MuiTableCell: (0, _TableCellTheme["default"])(colors, breakpoints),
    MuiTableHead: (0, _TableHeadTheme["default"])(colors, breakpoints),
    MuiTablePagination: (0, _TablePaginationTheme["default"])(colors),
    MuiTableRow: (0, _TableRowTheme["default"])(colors),
    MuiTableSortLabel: (0, _TableSortLabelTheme["default"])(),
    MuiSwitch: (0, _SwitchTheme["default"])(colors),
    MuiTabs: (0, _TabsTheme["default"])(),
    MuiTab: (0, _TabTheme["default"])(colors, breakpoints),
    MuiTextField: (0, _TextFieldTheme["default"])(),
    MuiToggleButton: (0, _ToggleButtonTheme["default"])(colors),
    MuiTooltip: (0, _TooltipTheme["default"])(colors, breakpoints),
    MuiTypography: (0, _TypographyTheme["default"])(colors, breakpoints),
    Calendar: (0, _CalendarTheme["default"])(colors, breakpoints)
  }
});
exports.theme = theme;